"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubLabel = exports.MainLabel = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.MainLabel = styled_components_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 14px;\n"], ["\n  color: ", ";\n  font-size: 14px;\n"])), function (props) { return props.theme.colors.tableBlack2; });
exports.SubLabel = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  color: ", ";\n"], ["\n  color: ", ";\n  font-size: 13px;\n  color: ", ";\n"])), function (props) { return props.theme.colors.tableGray1; }, function (props) { return props.theme.colors.tableBlack2; });
var templateObject_1, templateObject_2;
